import { render, staticRenderFns } from "./RequestAnswers.vue?vue&type=template&id=37f5c90a&scoped=true"
import script from "./RequestAnswers.vue?vue&type=script&lang=js"
export * from "./RequestAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f5c90a",
  null
  
)

export default component.exports